<div class="modal-header">
    <h3 *ngIf="!expired" class="modal-title" id="modal-title-id">You've been idle for a while..</h3>
    <h3 *ngIf="expired" class="modal-title" id="modal-title-id">{{LOCALIZATION.sessionTimeout}}</h3>
    <button *ngIf="!expired" class="close-x btn btn-xs btn-danger" (click)="extend()"><i class="fa fa-times fa-1x" aria-hidden="true"></i></button>
</div>
<div class="modal-body">
      <p *ngIf="!expired">
        You will be logged off in {{seconds}} seconds unless you choose to extend your session.
      <p> 
      <p *ngIf="expired">
        {{LOCALIZATION.sessionTimeoutMessage}}
      <p>         
</div>
<div class="modal-footer">
    <button *ngIf="!expired" class="btn btn-danger" type="button" (click)="logout()">{{LOCALIZATION.logout}}</button>
    <button *ngIf="!expired" class="btn btn-primary" type="button" (click)="extend()">Extend Your Session</button>
    <button *ngIf="expired" class="btn btn-primary" type="button" (click)="close()">{{LOCALIZATION.close}}</button>
</div>
        